import { skipToken, useQuery } from '@tanstack/react-query';

import { Search } from '@air/api';
import { type Board, type Library, type Workspace } from '@air/api/types';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const DEFAULT_LIMIT = 5;

const PRIVATE_SEARCH_SUGGESTIONS = 'PRIVATE_SEARCH_SUGGESTIONS';

export const getPrivateSuggestionsKey = (
  params: UsePrivateSearchSuggestionsParams & {
    workspaceId: Workspace['id'] | undefined;
  },
) => [PRIVATE_SEARCH_SUGGESTIONS, params];

export type UsePrivateSearchSuggestionsParams = {
  search: string;
  boardId?: Board['id'];
  libraryId?: Library['id'];
  canFetch: boolean;
  limit?: number;
};

export const usePrivateSearchSuggestions = ({
  search,
  boardId,
  canFetch,
  libraryId,
  limit = DEFAULT_LIMIT,
}: UsePrivateSearchSuggestionsParams) => {
  const { currentWorkspace } = useCurrentWorkspace();

  return useQuery({
    queryKey: getPrivateSuggestionsKey({
      search,
      boardId,
      libraryId,
      canFetch,
      limit,
      workspaceId: currentWorkspace?.id,
    }),

    queryFn: !currentWorkspace?.id
      ? skipToken
      : () => {
          return Search.getSuggestions({
            workspaceId: currentWorkspace.id,
            options: { search, limit, boardId, libraryId },
          });
        },
    enabled: !!currentWorkspace?.id && !!canFetch,
  });
};
